// @flow

import React, { Component } from 'react';
import { autobind } from 'core-decorators';
import { inject, observer } from 'mobx-react';

import BookingRequest from '../../models/BookingRequest/InternetBookingRequest';

import preload from './decorators/preload';
import DetailPageLayout from '../DetailPageLayout';
import BookingList from '../BookingList/InternetPackage';
import BreadcrumbLink from '../breadcrumbs/BreadcrumbLink';
import WithBookingConfirmation from '../BookingConfirmation/WithBookingConfirmation';
import BookingAssistant from '../BookingAssistant/InternetBookingAssistant';

import type MasterStore from '../../stores/MasterStore';
import type BookingUiStore from '../../stores/BookingUiStore';
import type Booking from '../../models/Booking';
import type InternetPackage from '../../models/InternetPackage';
import type BreadcrumbRouterStore from '../../stores/BreadcrumbRouterStore';
import { tealiumDateFromDateObject, tealiumIdFromString, tealiumValue } from '../../utils/tracking';
import tracking from '../../tracking';

@preload({ packageDetails: 'Internet' }, false)
@observer
class InternetDetailsBreadcrumb extends Component<{
  packageDetails: InternetPackage,
}> {
  render() {
    const { packageDetails } = this.props;

    return <BreadcrumbLink {...this.props} text={packageDetails.headline} />;
  }
}

type Props = {
  masterStore: MasterStore,
  bookingUiStore: BookingUiStore,
  packageDetails: InternetPackage,
  breadcrumbRouterStore: BreadcrumbRouterStore,
};

@inject('masterStore', 'bookingUiStore', 'breadcrumbRouterStore')
@preload({ packageDetails: 'Internet' })
@observer
export default class PageInternetDetails extends Component<Props> {
  static breadcrumb = InternetDetailsBreadcrumb;

  bookingRequest: BookingRequest;

  constructor(props: Props) {
    super(props);
    const { masterStore, packageDetails } = this.props;
    this.bookingRequest = new BookingRequest(
      masterStore.masterData.travelParty,
      packageDetails,
      masterStore.packagesOfUser
    );
  }

  @autobind
  handleBookingCancelClick(pkg: Booking) {
    this.bookingRequest.cancelBooking(pkg);
    this.props.bookingUiStore.openBookingDialog();
  }

  triggered = false;

  triggerTracking() {
    if (this.triggered === false) {
      this.triggered = true;
      tracking.pageView(window.location.pathname, ['internet-an-bord', this.props.packageDetails.title], 'product');
      tracking.viewItem(this.props.breadcrumbRouterStore, {
        category: this.props.packageDetails.analyticsCategory,
        categoryId: tealiumIdFromString(this.props.packageDetails.analyticsCategory),
        discount: '0.00',
        code: this.props.packageDetails.id,
        name: this.props.packageDetails.title,
        operator: {
          code: 'intern',
          name: 'intern-meinschiff',
        },
        quantity: '1',
        startDate: tealiumDateFromDateObject(new Date()),
        value: tealiumValue(String(this.bookingRequest.total)),
      });
    }
  }

  componentDidMount(): * {
    this.triggerTracking();
  }

  render() {
    const { masterStore, packageDetails, bookingUiStore } = this.props;

    return (
      <WithBookingConfirmation bookingRequest={this.bookingRequest}>
        <DetailPageLayout
          model={packageDetails}
          bookingList={() => (
            <BookingList
              header="Bereits reservierte Tarife:"
              bookings={this.bookingRequest.bookedPackagesOfSameType}
              user={masterStore.user}
              onCancelBooking={this.handleBookingCancelClick}
            />
          )}
          sidebar={(model) => (
            <BookingAssistant
              bookable={model}
              bookingRequest={this.bookingRequest}
              onBooking={() => {
                tracking.addToCart('1', this.bookingRequest.total);
                bookingUiStore.openBookingDialog();
              }}
            />
          )}
        />
      </WithBookingConfirmation>
    );
  }
}
